import * as React from 'react';
import { useStyles, useDebounceValue, useFetch } from '@sravni/react-utils';
import { Search } from '@sravni/react-icons';
import { Typography, Space, Button, Dialog, Autocomplete } from '@sravni/react-design-system';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

var modules_e5ab2127 = {"container":"RegionDialog_module_container__f0638e6b","content":"RegionDialog_module_content__f0638e6b","menu":"RegionDialog_module_menu__f0638e6b","list":"RegionDialog_module_list__f0638e6b","list__wrapper":"RegionDialog_module_list__wrapper__f0638e6b","list__item":"RegionDialog_module_list__item__f0638e6b","regionButton":"RegionDialog_module_regionButton__f0638e6b"};
import "./assets/index.esm-92426ccb.css";

var Text = Typography.Text;
var mergeLocations = function (regions) {
    var regionHash = {};
    regions.forEach(function (region) {
        var symbol = region.name[0].toUpperCase();
        if (regionHash[symbol]) {
            regionHash[symbol].push(region);
        }
        else {
            regionHash[symbol] = [region];
        }
    });
    return regionHash;
};
/**
 * @description RegionDialog component.
 *
 * @component
 * @example
 * ```jsx
 * <RegionDialog />
 * ```
 */
var RegionsList = React.forwardRef(function (props, ref) {
    var _a = props.regions, regions = _a === void 0 ? [] : _a, onSelect = props.onSelect;
    var cx = useStyles(modules_e5ab2127);
    var regionButtonClassnames = cx('regionButton');
    var regionsMap = React.useMemo(function () { return mergeLocations(regions); }, [regions]);
    var handleSelect = function (option) { return function (event) {
        event.preventDefault();
        onSelect(option);
    }; };
    return (React.createElement("div", { ref: ref, className: cx('list__wrapper') },
        React.createElement("div", { className: cx('list') }, Object.keys(regionsMap).map(function (symbol) { return (React.createElement("div", { key: symbol, className: cx('list__item') },
            React.createElement(Text, { size: 16, strong: true, className: "h-mb-8" }, symbol),
            React.createElement(Space, { size: 8, direction: "vertical" }, regionsMap[symbol].map(function (l) { return (React.createElement(Button, { key: l.id, "aria-label": l.alias, variant: "text", className: regionButtonClassnames, onClick: handleSelect(l) }, l.name)); })))); }))));
});
RegionsList.defaultProps = {
    title: 'Выберите город',
};

var getCurrentDomain = function () {
    var hostname = window.location.hostname;
    var domainLevels = hostname.split('.');
    var _a = __read(domainLevels); _a[0]; var restDomainLevels = _a.slice(1);
    if (domainLevels.length > 2)
        return "." + restDomainLevels.join('.');
    return "." + domainLevels.join('.');
};
function setRegionCookie(route) {
    var domain = getCurrentDomain();
    var date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    document.cookie = "_SL_" + "=" + route + "; domain=" + domain + "; path=/; expires=" + date.toUTCString();
}
/**
 * @description RegionDialog component.
 *
 * @component
 * @example
 * ```jsx
 * <RegionDialog />
 * ```
 */
var RegionDialog$1 = React.forwardRef(function (props, ref) {
    var title = props.title, subtitle = props.subtitle, icon = props.icon, serviceURL = props.serviceURL, regions = props.regions, formatPath = props.formatPath, getServiceUrl = props.getServiceUrl; props.onSelect; var onChange = props.onChange, onClose = props.onClose, className = props.className, restProps = __rest(props, ["title", "subtitle", "icon", "serviceURL", "regions", "formatPath", "getServiceUrl", "onSelect", "onChange", "onClose", "className"]);
    var cx = useStyles(modules_e5ab2127);
    var _a = __read(React.useState(undefined), 2), searchValue = _a[0], setSearchValue = _a[1];
    var debounceSearchValue = useDebounceValue(searchValue, 300);
    var _b = __read(useFetch(new URL('/suggest/v1/locations', "https://api.sravni.ru").toString()), 1), _c = _b[0], get = _c.get, data = _c.data, loading = _c.loading;
    var setSelectedRegionAndRedirect = function (region) { return __awaiter(void 0, void 0, void 0, function () {
        var path, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!getServiceUrl) return [3 /*break*/, 2];
                    return [4 /*yield*/, getServiceUrl(region)];
                case 1:
                    path = _b.sent();
                    return [3 /*break*/, 6];
                case 2:
                    if (!formatPath) return [3 /*break*/, 4];
                    return [4 /*yield*/, formatPath(region)];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = "" + serviceURL + region.alias;
                    _b.label = 5;
                case 5:
                    path = _a;
                    _b.label = 6;
                case 6:
                    setRegionCookie(region.route);
                    onClose && onClose();
                    location.href = path;
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChangeInput = React.useCallback(function (value) {
        setSearchValue(value);
    }, []);
    var handleSelect = React.useCallback(function (option) {
        onChange && onChange(option);
        setSelectedRegionAndRedirect(option);
    }, []);
    var handleChangeSelect = React.useCallback(
    // @ts-ignore
    function (value) {
        if (!data) {
            return [];
        }
        var option = data.find(function (o) { return value === o.id; });
        if (option) {
            onChange && onChange(option);
            setSelectedRegionAndRedirect(option);
        }
    }, [data]);
    var options = React.useMemo(function () {
        if (!data) {
            return [];
        }
        return data.map(function (item) { return ({ label: item.name, value: item.id }); });
    }, [data]);
    React.useEffect(function () {
        if (debounceSearchValue) {
            get({ q: debounceSearchValue });
        }
    }, [debounceSearchValue]);
    return (React.createElement(Dialog, __assign({ ref: ref, onClose: onClose }, restProps),
        React.createElement(Dialog.Header, { icon: icon, title: title, subtitle: subtitle }),
        React.createElement(Dialog.Content, { className: cx('content') },
            React.createElement("div", { className: cx(className, 'container') },
                React.createElement(Autocomplete, { placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0433\u043E\u0440\u043E\u0434\u0430", loading: loading, options: options, onSearch: handleChangeInput, onChange: handleChangeSelect, icon: React.createElement(Search, null) }),
                React.createElement(RegionsList, { regions: regions, onSelect: handleSelect })))));
});
RegionDialog$1.defaultProps = {
    title: 'Выберите город',
};

export { RegionDialog$1 as RegionDialog };
